// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"finalThoughts_backToTop__JmeYy","fadeIn":"finalThoughts_fadeIn__042G6"};